import EtablissementCongesSpec from '@/generated/controls/etablissement/EtablissementCongesSpec.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: EtablissementCongesSpec
})
